import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/api/supabase";
import {
  Email,
  EmailContextType,
  EmailContext,
} from "@/features/newsletterSettings/context/EmailContext";
import { useAuth } from "@/auth/useAuth";

export const EmailProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [emails, setEmails] = useState<Email[]>([]);
  const [loading, setLoading] = useState(false);
  const { session } = useAuth();
  const userEmail = session?.user.user_metadata.email;

  const fetchEmails = useCallback(async () => {
    if (!userEmail) {
      return;
    }

    try {
      setLoading(true);
      const { data, error } = await supabase
        .from("newsletter_emails")
        .select("*")
        .eq("email", userEmail);

      if (error) throw error;

      if (data) {
        setEmails(data || []);
      }
    } catch (error) {
      console.error("Error fetching newsletter config:", error);
    } finally {
      setLoading(false);
    }
  }, [userEmail]);

  useEffect(() => {
    fetchEmails();
    console.log("emails", emails);
  }, [fetchEmails]);

  const value: EmailContextType = {
    emails,
    fetchEmails,
    loading,
  };

  return (
    <EmailContext.Provider value={value}>{children}</EmailContext.Provider>
  );
};
